<script setup lang="ts">
const { siteOptions } = useSiteOptions();
</script>

<template>
  <div class="prose">
    <h4 v-html="siteOptions.messages.cart_confirmation.title" />
    <p v-html="siteOptions.messages.cart_confirmation.description" />
  </div>
</template>
